import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-0 bg-secondary-950 text-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg font-black text-background-50">
                51
              </span>
              <span className="font-heading text-lg font-black text-background-50">
                免费51漫画
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-300">
              免费51漫画按类型标签分类，热血类、搞笑类、少女漫、少年漫、完结作品、汉化组一应俱全。按标签筛选快速找到想看的漫画，追更更方便。
            </p>
            <div className="mt-5 flex gap-3">
              <a
                href="mailto:contact@free51manga.example"
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-800 text-secondary-200 transition-colors hover:bg-secondary-700"
                aria-label="发送邮件"
              >
                <i className="ri-mail-line"></i>
              </a>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-800 text-secondary-200 transition-colors hover:bg-secondary-700"
                aria-label="微博"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-800 text-secondary-200 transition-colors hover:bg-secondary-700"
                aria-label="微信公众号"
              >
                <i className="ri-wechat-line"></i>
              </a>
            </div>
          </div>

          <nav aria-label="热门分类">
            <h4 className="font-heading text-base font-bold text-background-50">热门分类</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link className="text-secondary-300 transition-colors hover:text-accent-300" to="/category/rexue">热血漫画</Link></li>
              <li><Link className="text-secondary-300 transition-colors hover:text-accent-300" to="/category/gaoxiao">搞笑漫画</Link></li>
              <li><Link className="text-secondary-300 transition-colors hover:text-accent-300" to="/category/shaonv">少女漫画</Link></li>
              <li><Link className="text-secondary-300 transition-colors hover:text-accent-300" to="/category/shaonian">少年漫画</Link></li>
              <li><Link className="text-secondary-300 transition-colors hover:text-accent-300" to="/category/hanzu">汉化组作品</Link></li>
            </ul>
          </nav>

          <nav aria-label="快速导航">
            <h4 className="font-heading text-base font-bold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link className="text-secondary-300 transition-colors hover:text-accent-300" to="/category/wanjie">完结漫画</Link></li>
              <li><Link className="text-secondary-300 transition-colors hover:text-accent-300" to="/about">关于我们</Link></li>
              <li><Link className="text-secondary-300 transition-colors hover:text-accent-300" to="/faq">常见问题</Link></li>
              <li><Link className="text-secondary-300 transition-colors hover:text-accent-300" to="/">最新更新</Link></li>
              <li><Link className="text-secondary-300 transition-colors hover:text-accent-300" to="/">本周热门</Link></li>
            </ul>
          </nav>

          <nav aria-label="内容准则">
            <h4 className="font-heading text-base font-bold text-background-50">内容准则</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-secondary-300">
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-accent-300"></i>
                <span>积极健康内容，拒绝盗版与侵权行为</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-refresh-line mt-0.5 text-accent-300"></i>
                <span>每日更新，紧跟连载进度</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-team-line mt-0.5 text-accent-300"></i>
                <span>精选优质汉化组作品</span>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-800 pt-6 text-xs text-secondary-400 sm:flex-row">
          <p>© 2026 免费51漫画 · 为用户提供优质的在线漫画阅读体验</p>
          <p className="flex items-center gap-1">
            <i className="ri-mail-send-line"></i>
            contact@free51manga.example
          </p>
        </div>
      </div>
    </footer>
  );
}